import React from 'react';
import styled from 'styled-components';

import { WrappedMenu } from '../components/new/Menu';
import { Footer } from '../components/new/Footer';
import { CustomBreadCrumbs } from '../components/new/CustomBreadCrumbs';
import { SEO } from '../components/seo';

import { Container } from '../components/Container';
import { Wrap } from '../components/new/Wrap';
import { H1 } from '../components/new/headers';
import { PageWrapper, ContentWrapper } from '../components/new/wrappers';
import { BaseTextStyle } from '../components/Styled';
import { SocialButtons } from '../components/new/SocialButtons';

// import Phone from '../images/icon-phone.svg';
// import Mail from '../images/icon-mail.svg';
// import Telegram from '../images/icon-telegram.svg';

const Text = styled(BaseTextStyle)`
    margin: 0;

    & + & {
        margin-top: 32px;
        @media screen and (max-width: 760px) {
            margin-top: 16px;
        }
    }
`;
const Table = styled.table`
    max-width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    text-align: left;
    margin: 48px 0 24px;
    border-bottom: 2px solid #000;

    tr:last-child {
        td {
            padding-bottom: 16px;
        }
    }

    th,
    td {
        font-family: 'Circe Web';
        font-size: 18px;
        line-height: 140%;

        @media screen and (max-width: 760px) {
            font-size: 16px;
            line-height: 140%;
        }
    }

    th {
        font-weight: 700;
        color: #000000;
        border-bottom: 2px solid;

        &:first-child {
            min-width: 192px;
            padding: 0 32px 0 0;
            box-sizing: border-box;

            @media screen and (max-width: 760px) {
                min-width: 80px;
                padding: 0 8px 0 0;
            }
        }
    }

    td {
        vertical-align: top;
        color: #404040;
        padding: 16px 32px 8px 0;
        box-sizing: border-box;

        a {
            color: #0b9cdb;

            &:hover {
                text-decoration: underline;
            }
        }

        @media screen and (max-width: 760px) {
            padding: 16px 8px 8px 0;
        }
    }
`;

const ContactsCardsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 48px 0;
    @media screen and (max-width: 760px) {
        flex-direction: column;
    }
`;

const ContactsCard = styled(BaseTextStyle)`
    align-items: center;
    text-decoration: none;
    padding: 24px 32px;
    box-shadow: 10px 15px 50px -5px rgba(0, 0, 0, 0.15);
    border-radius: 16px;
    transition: 0.3s ease 0s;
    font-weight: bold;
    width: 100%;
    justify-content: center;
    & + a {
        margin-left: 32px;
    }
    &:hover {
        color: #0b9cdb;
        transform: translateY(-4px);
        img {
            fill: #0b9cdb;
        }
    }
    @media screen and (max-width: 760px) {
        width: auto;
        & + a {
            margin-left: 0;
            margin-top: 24px;
        }
    }
`;

// const ContactsCardImage = styled.img`
//     display: inline-block;
//     max-height: 32px;
// `;

const ContactsPage = ({ pageContext }) => {
    // const isMobile = useIsMobile();
    const {
        breadcrumb: { crumbs },
    } = pageContext;
    return (
        <Wrap>
            <SEO
                title="Контакты"
                description="На данной странице вы можете ознакомиться с контактными данными компании КЭСПА"
            />
            <Container>
                <WrappedMenu />
                <PageWrapper
                    itemScope
                    itemType="https://schema.org/EducationalOrganization"
                >
                    <H1 as="h1">Контакты</H1>

                    <ContentWrapper>
                        <Text>
                            <b>
                                <span itemProp="name">
                                    КЭСПА – онлайн-школа английского языка
                                </span>
                            </b>
                        </Text>
                        <Text>
                            <b>Часы работы:</b>{' '}
                            <time
                                itemProp="openingHours"
                                dateTime="Mo-Sa 09:00-20:00"
                            >
                                пн-сб 09:00-20:00
                            </time>
                        </Text>
                        <Text
                            itemProp="address"
                            itemScope
                            itemType="https://schema.org/PostalAddress"
                        >
                            <meta itemProp="addressCountry" content="RU" />
                            <b>Адрес:</b>{' '}
                            <span itemProp="postalCode">115191</span>,{' '}
                            <span itemProp="addressLocality">г. Москва</span>,{' '}
                            <span itemProp="streetAddress">
                                Холодильный переулок, 3, корпус 1, стр. 8
                            </span>
                        </Text>
                        <Text>
                            <SocialButtons yt fb />
                        </Text>
                        <ContactsCardsWrapper>
                            <ContactsCard as="a" href="tel:+74996476044">
                                {/* <ContactsCardImage src={Phone} alt="" /> */}
                                Телефон <br />
                                <span itemProp="telephone">
                                    +7 (499) 647-60-44
                                </span>
                            </ContactsCard>
                            <ContactsCard as="a" href="mailto:student@kespa.ru">
                                {/* <ContactsCardImage src={Mail} alt="" /> */}
                                E-mail <br />
                                <span itemProp="email">student@kespa.ru</span>
                            </ContactsCard>
                            <ContactsCard
                                as="a"
                                href="https://teleg.run/KespaSchoolBot"
                            >
                                {/* <ContactsCardImage src={Telegram} alt="" /> */}
                                Telegram <br />
                                KespaSchoolBot
                            </ContactsCard>
                        </ContactsCardsWrapper>
                        <Table>
                            <tbody>
                                <tr>
                                    <th colSpan="2">Реквизиты</th>
                                </tr>
                                <tr>
                                    <td>Полное наименование организации</td>
                                    <td>
                                        Общество с ограниченной ответственностью
                                        &laquo;Система КЭСПА&raquo;
                                    </td>
                                </tr>
                                <tr>
                                    <td>Юридический адрес организации</td>
                                    <td>
                                        115191, Россия, Москва, Холодильный
                                        переулок, 3, корпус 1, стр. 8, подъезд 2
                                    </td>
                                </tr>
                                <tr>
                                    <td>ИНН</td>
                                    <td>7726467800</td>
                                </tr>
                                <tr>
                                    <td>ОГРН</td>
                                    <td>1207700322488</td>
                                </tr>
                                <tr>
                                    <td>Банк</td>
                                    <td>АО &laquo;АЛЬФА-БАНК&raquo;</td>
                                </tr>
                                <tr>
                                    <td>Расчетный счет</td>
                                    <td>40702810702860010180</td>
                                </tr>
                                <tr>
                                    <td>Юридический адрес банка</td>
                                    <td>
                                        107078, г. Москва, ул. Каланчевская, д.
                                        27
                                    </td>
                                </tr>
                                <tr>
                                    <td>Корр.счет банка</td>
                                    <td>30101810200000000593</td>
                                </tr>
                                <tr>
                                    <td>БИК банка</td>
                                    <td>044525593</td>
                                </tr>
                            </tbody>
                        </Table>
                    </ContentWrapper>
                </PageWrapper>

                <CustomBreadCrumbs crumbs={crumbs} />
            </Container>
            <Footer />
        </Wrap>
    );
};

export default ContactsPage;
